import { render, staticRenderFns } from "./Beitragsbemessungsgrenze.vue?vue&type=template&id=0c43c2cb&"
import script from "./Beitragsbemessungsgrenze.vue?vue&type=script&lang=js&"
export * from "./Beitragsbemessungsgrenze.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports